import { CategoryColorConfig } from '@posTypes';

export const CATEGORY_COLORS: readonly CategoryColorConfig[] = [
  {
    border: 'border-l-neon',
    divider: 'bg-neon/20',
    badge: 'bg-neon/10 text-neon',
    card: { border: 'border-neon/40', bg: 'bg-neon/5', text: 'text-neon' },
  },
  {
    border: 'border-l-blue-500',
    divider: 'bg-blue-500/20',
    badge: 'bg-blue-500/10 text-blue-400',
    card: { border: 'border-blue-500/40', bg: 'bg-blue-500/5', text: 'text-blue-400' },
  },
  {
    border: 'border-l-purple-500',
    divider: 'bg-purple-500/20',
    badge: 'bg-purple-500/10 text-purple-400',
    card: { border: 'border-purple-500/40', bg: 'bg-purple-500/5', text: 'text-purple-400' },
  },
  {
    border: 'border-l-pink-500',
    divider: 'bg-pink-500/20',
    badge: 'bg-pink-500/10 text-pink-400',
    card: { border: 'border-pink-500/40', bg: 'bg-pink-500/5', text: 'text-pink-400' },
  },
  {
    border: 'border-l-orange-500',
    divider: 'bg-orange-500/20',
    badge: 'bg-orange-500/10 text-orange-400',
    card: { border: 'border-orange-500/40', bg: 'bg-orange-500/5', text: 'text-orange-400' },
  },
  {
    border: 'border-l-teal-500',
    divider: 'bg-teal-500/20',
    badge: 'bg-teal-500/10 text-teal-400',
    card: { border: 'border-teal-500/40', bg: 'bg-teal-500/5', text: 'text-teal-400' },
  },
  {
    border: 'border-l-red-500',
    divider: 'bg-red-500/20',
    badge: 'bg-red-500/10 text-red-400',
    card: { border: 'border-red-500/40', bg: 'bg-red-500/5', text: 'text-red-400' },
  },
  {
    border: 'border-l-cyan-500',
    divider: 'bg-cyan-500/20',
    badge: 'bg-cyan-500/10 text-cyan-400',
    card: { border: 'border-cyan-500/40', bg: 'bg-cyan-500/5', text: 'text-cyan-400' },
  },
  {
    border: 'border-l-emerald-500',
    divider: 'bg-emerald-500/20',
    badge: 'bg-emerald-500/10 text-emerald-400',
    card: { border: 'border-emerald-500/40', bg: 'bg-emerald-500/5', text: 'text-emerald-400' },
  },
  {
    border: 'border-l-indigo-500',
    divider: 'bg-indigo-500/20',
    badge: 'bg-indigo-500/10 text-indigo-400',
    card: { border: 'border-indigo-500/40', bg: 'bg-indigo-500/5', text: 'text-indigo-400' },
  },
  {
    border: 'border-l-rose-500',
    divider: 'bg-rose-500/20',
    badge: 'bg-rose-500/10 text-rose-400',
    card: { border: 'border-rose-500/40', bg: 'bg-rose-500/5', text: 'text-rose-400' },
  },
  {
    border: 'border-l-lime-500',
    divider: 'bg-lime-500/20',
    badge: 'bg-lime-500/10 text-lime-400',
    card: { border: 'border-lime-500/40', bg: 'bg-lime-500/5', text: 'text-lime-400' },
  },
  {
    border: 'border-l-yellow-500',
    divider: 'bg-yellow-500/20',
    badge: 'bg-yellow-500/10 text-yellow-400',
    card: { border: 'border-yellow-500/40', bg: 'bg-yellow-500/5', text: 'text-yellow-400' },
  },
  {
    border: 'border-l-sky-500',
    divider: 'bg-sky-500/20',
    badge: 'bg-sky-500/10 text-sky-400',
    card: { border: 'border-sky-500/40', bg: 'bg-sky-500/5', text: 'text-sky-400' },
  },
  {
    border: 'border-l-violet-500',
    divider: 'bg-violet-500/20',
    badge: 'bg-violet-500/10 text-violet-400',
    card: { border: 'border-violet-500/40', bg: 'bg-violet-500/5', text: 'text-violet-400' },
  },
  {
    border: 'border-l-fuchsia-500',
    divider: 'bg-fuchsia-500/20',
    badge: 'bg-fuchsia-500/10 text-fuchsia-400',
    card: { border: 'border-fuchsia-500/40', bg: 'bg-fuchsia-500/5', text: 'text-fuchsia-400' },
  },
] as const;

export const FAVORITES_COLOR: CategoryColorConfig = {
  border: 'border-l-amber-500',
  divider: 'bg-amber-500/20',
  badge: 'bg-amber-500/10 text-amber-400',
  card: { border: 'border-amber-500/40', bg: 'bg-amber-500/5', text: 'text-amber-400' },
};
